<footer class="footer">
  <div class="mob_footer">
    <figure class="logo">
      <a routerLink="/">
        <img src="../../../../assets/image/asd.svg" alt="logo" />
      </a>
    </figure>
    <ul class="list">
      <li>
        <a href="https://x.com/hardikptm" rel="noopener" target="_blank">
          <p>Tw</p>
        </a>
      </li>
      <li>
        <a href="https://www.facebook.com/hardik.godhani.1675" rel="noopener" target="_blank">
          <p>Fb</p>
        </a>
      </li>
      <li>
        <a href="https://www.linkedin.com/in/godhani-hardik/" rel="noopener" target="_blank">
          <p>In</p>
        </a>
      </li>
      <li>
        <a routerLink="blog-first">
          <p>Bl</p>
        </a>
      </li>
      <li>
        <a href="https://www.instagram.com/the_ordinary_hardik/" rel="noopener" target="_blank">
          <p>Ig</p>
        </a>
      </li>
    </ul>
    <div class="text">
      <p>© 2021 Hardik Godhani. All rights reserved.</p>
    </div>
  </div>
</footer>
